import {
    DOWNLOAD_TO_EXCEL_SUCCESS,
    DOWNLOAD_TO_EXCEL_FAILURE,
    DOWNLOAD_TO_GDRIVE_SUCCESS,
    DOWNLOAD_TO_GDRIVE_FAILURE
} from './constants';
import {DownloadToExcelAction, DownloadToGDriveAction} from './typedef';

type IActions = DownloadToExcelAction & DownloadToGDriveAction;

const defaultState = {};

export const exportMenu = (state = defaultState, action: IActions) => {

    switch (action.type) {
        case DOWNLOAD_TO_EXCEL_SUCCESS:
            return {
                ...state,
                downloaded: 'success'
            };
        case DOWNLOAD_TO_EXCEL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case DOWNLOAD_TO_GDRIVE_SUCCESS:
            return {
                ...state,
                downloaded: 'success'
            };

        case DOWNLOAD_TO_GDRIVE_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default :
            return state;
    }
};
